// Translation utility
export const translations = {
  en: {
    nav: {
      services: 'SERVICES',
      about: 'ABOUT',
      blog: 'BLOG',
      inquire: 'INQUIRE HERE'
    },
    hero: {
      title: 'Finding cars their',
      titleItalic: 'perfect home',
      subtitle: 'Each car has a story, a life, a soul.'
    },
    quote: {
      text: 'You cannot describe passion. You can only live it.',
      author: 'Enzo Ferrari'
    },
    blogQuote: {
      text: 'The car is the closest thing we will ever create to something that is alive.',
      author: 'Sir William Lyons'
    },
    services: {
      button: 'Our Services'
    },
    blog: {
      title: 'Revs Tales',
      subtitle: "Each car carries a story—a life, a soul. We document those stories not to preserve the past—but to carry it forward.",
      seeAll: 'See All',
      readMore: 'read more',
      category: {
        vehicleSpotlights: 'Vehicle Spotlights',
        marketTrends: 'Market Trends',
        buyersGuide: "Buyer's Guide"
      }
    },
    cta: {
      title: 'Begin a conversation.',
      subtitle: 'When the time is right, we are here.',
      button: 'Contact Us'
    },
    footer: {
      description: 'We are only passing through as custodians.\nGuiding what continues — quietly, and with intention.',
      quickLinks: 'QUICK LINKS',
      events: 'EVENTS',
      shop: 'SHOP',
      careers: 'CAREERS',
      academy: 'ACADEMY',
      services: 'SERVICES',
      contact: 'CONTACT',
      location: 'Orlando, Florida\nUnited States',
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    },
    servicesPage: {
      title: 'Private Automotive Advisory',
      subtitle: 'Discreet advisory services for collectors navigating the global market for rare, exotic, and investment-grade automobiles.',
      carFinder: {
        title: 'Revs Finder',
        subtitle: 'Vehicle Acquisition Advisory',
        description: 'Professional guidance for collectors seeking rare, exotic, and investment-grade automobiles. Through an extensive network within the global collector market, we identify and source vehicles that meet a client\'s precise specifications while providing strategic insight into pricing, provenance, and market timing. Through long-standing relationships within the collector community, dealer networks, and private ownership circles, we often gain access to vehicles that are not publicly offered on the open market.'
      },
      acquisition: {
        title: 'Acquisition & Brokerage',
        description: 'Specializing in luxury, exotic, and classic vehicles. We handle the entire acquisition process from start to finish.'
      },
      consignment: {
        title: 'Revs Seller',
        subtitle: 'Vehicle Sales Advisory',
        description: 'Professional guidance for collectors seeking to position rare, exotic, and investment-grade automobiles within the global collector market. Leveraging an extensive network of collectors, dealers, brokers, and qualified buyers, we strategically present vehicles to the appropriate audience while providing insight into pricing strategy, provenance, and optimal market timing. Through long-standing relationships within the collector community, dealer networks, and private ownership circles, we are often able to introduce vehicles to serious buyers before they are broadly marketed to the public.'
      },
      valuation: {
        title: 'Market Intelligence & Consulting',
        description: 'Professional insight into collector vehicle markets, pricing dynamics, and emerging trends across the global exotic, classic, and luxury automotive landscape. Drawing on knowledge of collector demand, auction performance, and private market activity, we provide strategic guidance to help clients understand market positioning, vehicle value, and optimal timing for acquisition or sale decisions.'
      },
      privateMarket: {
        title: 'Private Market Transactions',
        description: 'Discreet coordination of private collector vehicle transactions. Our approach prioritizes confidentiality, qualified buyers, and carefully structured deals.'
      },
      appraisal: {
        title: 'Market Valuation & Appraisal',
        description: 'Independent valuation and appraisal services for collectors preparing vehicles for private sale, collection planning, or market positioning. Our assessments are informed by current market data, transaction history, and deep knowledge of collector vehicle markets.'
      },
      collectionAdvisory: {
        title: 'Collection Advisory',
        description: 'Strategic guidance for collectors building, refining, or repositioning automotive collections. Our advisory approach combines market intelligence, acquisition strategy, and collector insight to help clients make informed long-term decisions.'
      },
      whyClients: {
        title: 'Why Clients Work With Revs Vibes',
        description: 'Trusted relationships across global collector networks allow us to identify rare vehicles, structure discreet transactions, and provide independent advisory tailored to each client\'s objectives.',
        features: [
          'Access to off-market opportunities',
          'Independent advisory aligned with client interests',
          'Global collector network relationships',
          'Discreet transaction management'
        ]
      }
    },
    about: {
      title: 'About Revs Vibes',
      subtitle: 'Preserving automotive history, one supercar at a time',
      mission: 'Our Mission',
      values: 'Our Values',
      story: 'Our Story'
    },
    contact: {
      title: 'Get In Touch',
      subtitle: "We're here to help with all your automotive needs",
      send: 'Send Message',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      subject: 'Subject',
      message: 'Message'
    }
  },
  es: {
    nav: {
      services: 'SERVICIOS',
      about: 'ACERCA DE',
      blog: 'BLOG',
      inquire: 'CONSULTAR AQUÍ'
    },
    hero: {
      title: 'Encontrando autos su',
      titleItalic: 'hogar perfecto',
      subtitle: 'Cada auto tiene una historia, una vida, un alma.'
    },
    quote: {
      text: 'No puedes describir la pasión. Solo puedes vivirla.',
      author: 'Enzo Ferrari'
    },
    blogQuote: {
      text: 'El auto es lo más cercano que crearemos a algo que está vivo.',
      author: 'Sir William Lyons'
    },
    hero: {
      title: 'Encontrando autos su',
      titleItalic: 'hogar perfecto',
      subtitle: 'Cada auto tiene una historia, una vida, un alma.'
    },
    services: {
      button: 'Nuestros Servicios'
    },
    blog: {
      title: 'Revs Tales',
      subtitle: 'Cada auto lleva una historia—una vida, un alma. Documentamos esas historias no para preservar el pasado—sino para llevarlo adelante.',
      seeAll: 'Ver Todo',
      readMore: 'leer más',
      category: {
        vehicleSpotlights: 'Destacados de Vehículos',
        marketTrends: 'Tendencias del Mercado',
        buyersGuide: 'Guía del Comprador'
      }
    },
    cta: {
      title: 'Inicia una conversación.',
      subtitle: 'Cuando el momento sea el adecuado, estaremos aquí.',
      button: 'Contáctanos'
    },
    footer: {
      description: 'Solo estamos de paso como custodios.\nGuiando lo que continúa — en silencio, y con intención.',
      quickLinks: 'ENLACES RÁPIDOS',
      events: 'EVENTOS',
      shop: 'TIENDA',
      careers: 'CARRERAS',
      academy: 'ACADEMIA',
      services: 'SERVICIOS',
      contact: 'CONTACTO',
      location: 'Orlando, Florida\nEstados Unidos',
      rights: 'Todos los derechos reservados',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio'
    },
    servicesPage: {
      title: 'Asesoría Automotriz Privada',
      subtitle: 'Servicios de asesoría discreta para coleccionistas que navegan el mercado global de automóviles raros, exóticos y de grado de inversión.',
      carFinder: {
        title: 'Revs Finder',
        subtitle: 'Asesoría en Adquisición de Automóviles de Colección',
        description: 'Orientación profesional para coleccionistas que buscan automóviles raros, exóticos y de grado de inversión. A través de una extensa red dentro del mercado global de coleccionistas, identificamos y buscamos vehículos que cumplan con las especificaciones precisas del cliente mientras proporcionamos información estratégica sobre precios, procedencia y momento del mercado. A través de relaciones de larga data dentro de la comunidad de coleccionistas, redes de distribuidores y círculos de propiedad privada, frecuentemente obtenemos acceso a vehículos que no se ofrecen públicamente en el mercado abierto.'
      },
      acquisition: {
        title: 'Adquisición y Corretaje',
        description: 'Especializados en vehículos de lujo, exóticos y clásicos. Manejamos todo el proceso de adquisición de principio a fin.'
      },
      consignment: {
        title: 'Revs Seller',
        subtitle: 'Asesoría para la Venta de Automóviles de Colección',
        description: 'Orientación profesional para coleccionistas que buscan posicionar automóviles raros, exóticos y de grado de inversión dentro del mercado global de coleccionistas. Aprovechando una extensa red de coleccionistas, distribuidores, corredores y compradores calificados, presentamos estratégicamente vehículos a la audiencia apropiada mientras proporcionamos información sobre estrategia de precios, procedencia y momento óptimo del mercado. A través de relaciones de larga data dentro de la comunidad de coleccionistas, redes de distribuidores y círculos de propiedad privada, frecuentemente podemos presentar vehículos a compradores serios antes de que sean ampliamente comercializados al público.'
      },
      valuation: {
        title: 'Inteligencia de Mercado y Consultoría',
        description: 'Información profesional sobre mercados de vehículos de colección, dinámicas de precios y tendencias emergentes en el panorama automotriz global de exóticos, clásicos y lujo. Basándonos en el conocimiento de la demanda de coleccionistas, rendimiento de subastas y actividad del mercado privado, proporcionamos orientación estratégica para ayudar a los clientes a comprender el posicionamiento del mercado, el valor del vehículo y el momento óptimo para decisiones de adquisición o venta.'
      },
      privateMarket: {
        title: 'Transacciones de Mercado Privado',
        description: 'Coordinación discreta de transacciones privadas de vehículos de colección. Nuestro enfoque prioriza la confidencialidad, compradores calificados y acuerdos cuidadosamente estructurados.'
      },
      appraisal: {
        title: 'Valuación y Tasación de Mercado',
        description: 'Servicios independientes de valuación y tasación para coleccionistas que preparan vehículos para venta privada, planificación de colección o posicionamiento en el mercado. Nuestras evaluaciones se basan en datos actuales del mercado, historial de transacciones y profundo conocimiento de los mercados de vehículos de colección.'
      },
      collectionAdvisory: {
        title: 'Asesoría de Colecciones',
        description: 'Orientación estratégica para coleccionistas que construyen, refinan o reposicionan colecciones automotrices. Nuestro enfoque de asesoría combina inteligencia de mercado, estrategia de adquisición y conocimiento de coleccionistas para ayudar a los clientes a tomar decisiones informadas a largo plazo.'
      },
      whyClients: {
        title: 'Por Qué los Clientes Trabajan con Revs Vibes',
        description: 'Las relaciones de confianza en las redes globales de coleccionistas nos permiten identificar vehículos raros, estructurar transacciones discretas y proporcionar asesoría independiente adaptada a los objetivos de cada cliente.',
        features: [
          'Acceso a oportunidades fuera del mercado',
          'Asesoría independiente alineada con los intereses del cliente',
          'Relaciones con redes globales de coleccionistas',
          'Gestión discreta de transacciones'
        ]
      }
    },
    about: {
      title: 'Acerca de Revs Vibes',
      subtitle: 'Preservando la historia automotriz, un superdeportivo a la vez',
      mission: 'Nuestra Misión',
      values: 'Nuestros Valores',
      story: 'Nuestra Historia'
    },
    contact: {
      title: 'Ponte en Contacto',
      subtitle: 'Estamos aquí para ayudar con todas tus necesidades automotrices',
      send: 'Enviar Mensaje',
      name: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Número de Teléfono',
      subject: 'Asunto',
      message: 'Mensaje'
    }
  },
  pt: {
    nav: {
      services: 'SERVIÇOS',
      about: 'SOBRE',
      blog: 'BLOG',
      inquire: 'PERGUNTE AQUI'
    },
    hero: {
      title: 'Encontrando carros seu',
      titleItalic: 'lar perfeito',
      subtitle: 'Cada carro tem uma história, uma vida, uma alma.'
    },
    quote: {
      text: 'Você não pode descrever a paixão. Você só pode vivê-la.',
      author: 'Enzo Ferrari'
    },
    blogQuote: {
      text: 'O carro é a coisa mais próxima que criaremos de algo que está vivo.',
      author: 'Sir William Lyons'
    },
    hero: {
      title: 'Encontrando carros seu',
      titleItalic: 'lar perfeito',
      subtitle: 'Cada carro tem uma história, uma vida, uma alma.'
    },
    services: {
      button: 'Nossos Serviços'
    },
    blog: {
      title: 'Revs Tales',
      subtitle: 'Cada carro carrega uma história—uma vida, uma alma. Documentamos essas histórias não para preservar o passado—mas para levá-lo adiante.',
      seeAll: 'Ver Tudo',
      readMore: 'leia mais',
      category: {
        vehicleSpotlights: 'Destaques de Veículos',
        marketTrends: 'Tendências do Mercado',
        buyersGuide: 'Guia do Comprador'
      }
    },
    cta: {
      title: 'Inicie uma conversa.',
      subtitle: 'Quando o momento for o certo, estaremos aqui.',
      button: 'Contate-nos'
    },
    footer: {
      description: 'Estamos apenas de passagem como guardiões.\nGuiando o que continua — em silêncio, e com intenção.',
      quickLinks: 'LINKS RÁPIDOS',
      events: 'EVENTOS',
      shop: 'LOJA',
      careers: 'CARREIRAS',
      academy: 'ACADEMIA',
      services: 'SERVIÇOS',
      contact: 'CONTATO',
      location: 'Orlando, Flórida\nEstados Unidos',
      rights: 'Todos os direitos reservados',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Serviço'
    },
    servicesPage: {
      title: 'Consultoria Automotiva Privada',
      subtitle: 'Serviços de consultoria discreta para colecionadores que navegam no mercado global de automóveis raros, exóticos e de grau de investimento.',
      carFinder: {
        title: 'Revs Finder',
        subtitle: 'Consultoria em Aquisição de Automóveis de Coleção',
        description: 'Orientação profissional para colecionadores que buscam automóveis raros, exóticos e de grau de investimento. Através de uma extensa rede dentro do mercado global de colecionadores, identificamos e buscamos veículos que atendam às especificações precisas do cliente enquanto fornecemos insights estratégicos sobre preços, procedência e momento do mercado. Através de relacionamentos de longa data dentro da comunidade de colecionadores, redes de revendedores e círculos de propriedade privada, frequentemente obtemos acesso a veículos que não são oferecidos publicamente no mercado aberto.'
      },
      acquisition: {
        title: 'Aquisição e Corretagem',
        description: 'Especializados em veículos de luxo, exóticos e clássicos. Lidamos com todo o processo de aquisição do início ao fim.'
      },
      consignment: {
        title: 'Revs Seller',
        subtitle: 'Consultoria para Venda de Automóveis de Coleção',
        description: 'Orientação profissional para colecionadores que buscam posicionar automóveis raros, exóticos e de grau de investimento dentro do mercado global de colecionadores. Aproveitando uma extensa rede de colecionadores, revendedores, corretores e compradores qualificados, apresentamos estrategicamente veículos ao público apropriado enquanto fornecemos insights sobre estratégia de preços, procedência e momento ideal do mercado. Através de relacionamentos de longa data dentro da comunidade de colecionadores, redes de revendedores e círculos de propriedade privada, frequentemente conseguimos apresentar veículos a compradores sérios antes de serem amplamente comercializados ao público.'
      },
      valuation: {
        title: 'Inteligência de Mercado e Consultoria',
        description: 'Insights profissionais sobre mercados de veículos de coleção, dinâmicas de preços e tendências emergentes no panorama automotivo global de exóticos, clássicos e luxo. Com base no conhecimento da demanda de colecionadores, desempenho de leilões e atividade do mercado privado, fornecemos orientação estratégica para ajudar os clientes a entender o posicionamento do mercado, o valor do veículo e o momento ideal para decisões de aquisição ou venda.'
      },
      privateMarket: {
        title: 'Transações de Mercado Privado',
        description: 'Coordenação discreta de transações privadas de veículos de coleção. Nossa abordagem prioriza a confidencialidade, compradores qualificados e acordos cuidadosamente estruturados.'
      },
      appraisal: {
        title: 'Avaliação e Perícia de Mercado',
        description: 'Serviços independentes de avaliação e perícia para colecionadores que preparam veículos para venda privada, planejamento de coleção ou posicionamento no mercado. Nossas avaliações são baseadas em dados atuais do mercado, histórico de transações e profundo conhecimento dos mercados de veículos de coleção.'
      },
      collectionAdvisory: {
        title: 'Consultoria de Coleções',
        description: 'Orientação estratégica para colecionadores que constroem, refinam ou reposicionam coleções automotivas. Nossa abordagem de consultoria combina inteligência de mercado, estratégia de aquisição e conhecimento de colecionadores para ajudar os clientes a tomar decisões informadas a longo prazo.'
      },
      whyClients: {
        title: 'Por Que os Clientes Trabalham com a Revs Vibes',
        description: 'Relacionamentos de confiança em redes globais de colecionadores nos permitem identificar veículos raros, estruturar transações discretas e fornecer consultoria independente adaptada aos objetivos de cada cliente.',
        features: [
          'Acesso a oportunidades fora do mercado',
          'Consultoria independente alinhada com os interesses do cliente',
          'Relacionamentos com redes globais de colecionadores',
          'Gestão discreta de transações'
        ]
      }
    },
    about: {
      title: 'Sobre Revs Vibes',
      subtitle: 'Preservando a história automotiva, um supercarro por vez',
      mission: 'Nossa Missão',
      values: 'Nossos Valores',
      story: 'Nossa História'
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Estamos aqui para ajudar com todas as suas necessidades automotivas',
      send: 'Enviar Mensagem',
      name: 'Nome Completo',
      email: 'Endereço de E-mail',
      phone: 'Número de Telefone',
      subject: 'Assunto',
      message: 'Mensagem'
    }
  },
  fr: {
    nav: {
      services: 'SERVICES',
      about: 'À PROPOS',
      blog: 'BLOG',
      inquire: 'DEMANDER ICI'
    },
    hero: {
      title: 'Trouver aux voitures leur',
      titleItalic: 'foyer parfait',
      subtitle: 'Chaque voiture a une histoire, une vie, une âme.'
    },
    quote: {
      text: 'On ne peut pas décrire la passion. On ne peut que la vivre.',
      author: 'Enzo Ferrari'
    },
    blogQuote: {
      text: 'La voiture est la chose la plus proche que nous créerons jamais de quelque chose de vivant.',
      author: 'Sir William Lyons'
    },
    hero: {
      title: 'Trouver aux voitures leur',
      titleItalic: 'foyer parfait',
      subtitle: 'Chaque voiture a une histoire, une vie, une âme.'
    },
    services: {
      button: 'Nos Services'
    },
    blog: {
      title: 'Revs Tales',
      subtitle: 'Chaque voiture porte une histoire—une vie, une âme. Nous documentons ces histoires non pour préserver le passé—mais pour le porter en avant.',
      seeAll: 'Voir Tout',
      readMore: 'lire plus',
      category: {
        vehicleSpotlights: 'Points Saillants des Véhicules',
        marketTrends: 'Tendances du Marché',
        buyersGuide: 'Guide de l\'Acheteur'
      }
    },
    cta: {
      title: 'Engagez la conversation.',
      subtitle: 'Quand le moment sera venu, nous serons là.',
      button: 'Contactez-nous'
    },
    footer: {
      description: 'Nous ne faisons que passer, comme dépositaires.\nGuidant ce qui perdure — en silence, et avec intention.',
      quickLinks: 'LIENS RAPIDES',
      events: 'ÉVÉNEMENTS',
      shop: 'BOUTIQUE',
      careers: 'CARRIÈRES',
      academy: 'ACADÉMIE',
      services: 'SERVICES',
      contact: 'CONTACT',
      location: 'Orlando, Floride\nÉtats-Unis',
      rights: 'Tous droits réservés',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions de Service'
    },
    servicesPage: {
      title: 'Conseil Automobile Privé',
      subtitle: 'Services de conseil discrets pour les collectionneurs naviguant sur le marché mondial des automobiles rares, exotiques et de qualité investissement.',
      carFinder: {
        title: 'Revs Finder',
        subtitle: 'Conseil Privé en Acquisition d\'Automobiles de Collection',
        description: 'Conseils professionnels pour les collectionneurs à la recherche d\'automobiles rares, exotiques et de qualité investissement. À travers un vaste réseau au sein du marché mondial des collectionneurs, nous identifions et recherchons des véhicules qui répondent aux spécifications précises du client tout en fournissant des informations stratégiques sur les prix, la provenance et le timing du marché. Grâce à des relations de longue date au sein de la communauté des collectionneurs, des réseaux de concessionnaires et des cercles de propriété privée, nous obtenons souvent accès à des véhicules qui ne sont pas offerts publiquement sur le marché ouvert.'
      },
      acquisition: {
        title: 'Acquisition et Courtage',
        description: 'Spécialisés dans les véhicules de luxe, exotiques et classiques. Nous gérons l\'ensemble du processus d\'acquisition du début à la fin.'
      },
      consignment: {
        title: 'Revs Seller',
        subtitle: 'Conseil Privé en Vente d\'Automobiles de Collection',
        description: 'Conseils professionnels pour les collectionneurs cherchant à positionner des automobiles rares, exotiques et de qualité investissement sur le marché mondial des collectionneurs. En exploitant un vaste réseau de collectionneurs, concessionnaires, courtiers et acheteurs qualifiés, nous présentons stratégiquement les véhicules au public approprié tout en fournissant des informations sur la stratégie de prix, la provenance et le timing optimal du marché. Grâce à des relations de longue date au sein de la communauté des collectionneurs, des réseaux de concessionnaires et des cercles de propriété privée, nous sommes souvent en mesure de présenter des véhicules à des acheteurs sérieux avant qu\'ils ne soient largement commercialisés au public.'
      },
      valuation: {
        title: 'Intelligence de Marché et Conseil',
        description: 'Aperçu professionnel des marchés de véhicules de collection, des dynamiques de prix et des tendances émergentes dans le paysage automobile mondial des exotiques, classiques et de luxe. En s\'appuyant sur la connaissance de la demande des collectionneurs, des performances aux enchères et de l\'activité du marché privé, nous fournissons des conseils stratégiques pour aider les clients à comprendre le positionnement sur le marché, la valeur du véhicule et le moment optimal pour les décisions d\'acquisition ou de vente.'
      },
      privateMarket: {
        title: 'Transactions sur le Marché Privé',
        description: 'Coordination discrète des transactions privées de véhicules de collection. Notre approche privilégie la confidentialité, les acheteurs qualifiés et les accords soigneusement structurés.'
      },
      appraisal: {
        title: 'Évaluation et Expertise de Marché',
        description: 'Services indépendants d\'évaluation et d\'expertise pour les collectionneurs préparant des véhicules pour la vente privée, la planification de collection ou le positionnement sur le marché. Nos évaluations sont basées sur les données actuelles du marché, l\'historique des transactions et une connaissance approfondie des marchés de véhicules de collection.'
      },
      collectionAdvisory: {
        title: 'Conseil en Collections',
        description: 'Orientation stratégique pour les collectionneurs qui construisent, affinent ou repositionnent des collections automobiles. Notre approche de conseil combine intelligence de marché, stratégie d\'acquisition et connaissance des collectionneurs pour aider les clients à prendre des décisions éclairées à long terme.'
      },
      whyClients: {
        title: 'Pourquoi les Clients Travaillent avec Revs Vibes',
        description: 'Des relations de confiance au sein des réseaux mondiaux de collectionneurs nous permettent d\'identifier des véhicules rares, de structurer des transactions discrètes et de fournir des conseils indépendants adaptés aux objectifs de chaque client.',
        features: [
          'Accès aux opportunités hors marché',
          'Conseil indépendant aligné sur les intérêts du client',
          'Relations avec les réseaux mondiaux de collectionneurs',
          'Gestion discrète des transactions'
        ]
      }
    },
    about: {
      title: 'À propos de Revs Vibes',
      subtitle: 'Préserver l\'histoire automobile, une supercar à la fois',
      mission: 'Notre Mission',
      values: 'Nos Valeurs',
      story: 'Notre Histoire'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes là pour vous aider avec tous vos besoins automobiles',
      send: 'Envoyer le Message',
      name: 'Nom Complet',
      email: 'Adresse E-mail',
      phone: 'Numéro de Téléphone',
      subject: 'Sujet',
      message: 'Message'
    }
  },
  it: {
    nav: {
      services: 'SERVIZI',
      about: 'CHI SIAMO',
      blog: 'BLOG',
      inquire: 'RICHIEDI QUI'
    },
    hero: {
      title: 'Trovare alle auto la loro',
      titleItalic: 'casa perfetta',
      subtitle: 'Ogni auto ha una storia, una vita, un\'anima.'
    },
    quote: {
      text: 'Non puoi descrivere la passione. Puoi solo viverla.',
      author: 'Enzo Ferrari'
    },
    blogQuote: {
      text: "L'auto è la cosa più vicina che creeremo mai a qualcosa di vivo.",
      author: 'Sir William Lyons'
    },
    hero: {
      title: 'Trovare alle auto la loro',
      titleItalic: 'casa perfetta',
      subtitle: 'Ogni auto ha una storia, una vita, un\'anima.'
    },
    services: {
      button: 'I Nostri Servizi'
    },
    blog: {
      title: 'Revs Tales',
      subtitle: 'Ogni auto porta una storia—una vita, un\'anima. Documentiamo quelle storie non per preservare il passato—ma per portarlo avanti.',
      seeAll: 'Vedi Tutto',
      readMore: 'leggi di più',
      category: {
        vehicleSpotlights: 'Vetture in Primo Piano',
        marketTrends: 'Tendenze del Mercato',
        buyersGuide: 'Guida dell\'Acquirente'
      }
    },
    cta: {
      title: 'Inizia una conversazione.',
      subtitle: 'Quando il momento sarà giusto, saremo qui.',
      button: 'Contattaci'
    },
    footer: {
      description: 'Siamo solo di passaggio come custodi.\nGuidando ciò che continua — in silenzio, e con intenzione.',
      quickLinks: 'LINK RAPIDI',
      events: 'EVENTI',
      shop: 'NEGOZIO',
      careers: 'CARRIERE',
      academy: 'ACCADEMIA',
      services: 'SERVIZI',
      contact: 'CONTATTO',
      location: 'Orlando, Florida\nStati Uniti',
      rights: 'Tutti i diritti riservati',
      privacy: 'Informativa sulla Privacy',
      terms: 'Termini di Servizio'
    },
    servicesPage: {
      title: 'Consulenza Automobilistica Privata',
      subtitle: 'Servizi di consulenza discreta per collezionisti che navigano nel mercato globale di automobili rare, esotiche e di grado investimento.',
      carFinder: {
        title: 'Revs Finder',
        subtitle: 'Consulenza per l\'Acquisizione di Automobili da Collezione',
        description: 'Guida professionale per collezionisti alla ricerca di automobili rare, esotiche e di grado investimento. Attraverso un\'ampia rete all\'interno del mercato globale dei collezionisti, identifichiamo e reperiamo veicoli che soddisfano le specifiche precise del cliente fornendo al contempo informazioni strategiche su prezzi, provenienza e tempistica di mercato. Attraverso relazioni di lunga data all\'interno della comunità dei collezionisti, reti di concessionari e circoli di proprietà privata, spesso otteniamo accesso a veicoli che non sono offerti pubblicamente sul mercato aperto.'
      },
      acquisition: {
        title: 'Acquisizione e Intermediazione',
        description: 'Specializzati in veicoli di lusso, esotici e classici. Gestiamo l\'intero processo di acquisizione dall\'inizio alla fine.'
      },
      consignment: {
        title: 'Revs Seller',
        subtitle: 'Consulenza per la Vendita di Automobili da Collezione',
        description: 'Guida professionale per collezionisti che cercano di posizionare automobili rare, esotiche e di grado investimento nel mercato globale dei collezionisti. Sfruttando un\'ampia rete di collezionisti, concessionari, broker e acquirenti qualificati, presentiamo strategicamente i veicoli al pubblico appropriato fornendo al contempo informazioni sulla strategia dei prezzi, provenienza e tempistica ottimale del mercato. Attraverso relazioni di lunga data all\'interno della comunità dei collezionisti, reti di concessionari e circoli di proprietà privata, siamo spesso in grado di presentare veicoli ad acquirenti seri prima che vengano ampiamente commercializzati al pubblico.'
      },
      valuation: {
        title: 'Intelligenza di Mercato e Consulenza',
        description: 'Approfondimenti professionali sui mercati dei veicoli da collezione, dinamiche dei prezzi e tendenze emergenti nel panorama automobilistico globale di esotici, classici e lusso. Basandoci sulla conoscenza della domanda dei collezionisti, delle performance delle aste e dell\'attività del mercato privato, forniamo una guida strategica per aiutare i clienti a comprendere il posizionamento sul mercato, il valore del veicolo e il momento ottimale per le decisioni di acquisizione o vendita.'
      },
      privateMarket: {
        title: 'Transazioni di Mercato Privato',
        description: 'Coordinamento discreto di transazioni private di veicoli da collezione. Il nostro approccio dà priorità alla riservatezza, agli acquirenti qualificati e agli accordi attentamente strutturati.'
      },
      appraisal: {
        title: 'Valutazione e Perizia di Mercato',
        description: 'Servizi indipendenti di valutazione e perizia per collezionisti che preparano veicoli per la vendita privata, pianificazione della collezione o posizionamento sul mercato. Le nostre valutazioni si basano sui dati attuali del mercato, sulla cronologia delle transazioni e sulla profonda conoscenza dei mercati dei veicoli da collezione.'
      },
      collectionAdvisory: {
        title: 'Consulenza per Collezioni',
        description: 'Orientamento strategico per collezionisti che costruiscono, perfezionano o riposizionano collezioni automobilistiche. Il nostro approccio di consulenza combina intelligenza di mercato, strategia di acquisizione e conoscenza dei collezionisti per aiutare i clienti a prendere decisioni informate a lungo termine.'
      },
      whyClients: {
        title: 'Perché i Clienti Lavorano con Revs Vibes',
        description: 'Relazioni di fiducia nelle reti globali di collezionisti ci permettono di identificare veicoli rari, strutturare transazioni discrete e fornire consulenza indipendente su misura per gli obiettivi di ogni cliente.',
        features: [
          'Accesso a opportunità fuori mercato',
          'Consulenza indipendente allineata agli interessi del cliente',
          'Relazioni con reti globali di collezionisti',
          'Gestione discreta delle transazioni'
        ]
      }
    },
    about: {
      title: 'Chi Siamo Revs Vibes',
      subtitle: 'Preservare la storia automobilistica, una supercar alla volta',
      mission: 'La Nostra Missione',
      values: 'I Nostri Valori',
      story: 'La Nostra Storia'
    },
    contact: {
      title: 'Mettiti in Contatto',
      subtitle: 'Siamo qui per aiutarti con tutte le tue esigenze automobilistiche',
      send: 'Invia Messaggio',
      name: 'Nome Completo',
      email: 'Indirizzo Email',
      phone: 'Numero di Telefono',
      subject: 'Oggetto',
      message: 'Messaggio'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      return translations.en[keys[0]]?.[keys[1]] || key;
    }
  }
  
  return value;
};